import React from 'react';
import './LeftNavBar.css';
import { NavLink, withRouter } from 'react-router-dom';
import RoutesConstants from '../Routes/routes.constants';
import { FormattedMessage, injectIntl } from 'react-intl';
import CentraIoTLogo from '../../../assets/Images/logo/Centra-IoT_Landscape_HQ.png';
import CentraIoT_icon from '../../../assets/Images/logo/CentraIoT_32.png';
import userIcon from '../../../assets/Images/user32.png';
import sensorIcon from '../../../assets/Images/sensor32.png';
import dashboardIcon from '../../../assets/Images/dashboard.svg';
import downloadIcon from '../../../assets/Images/download.png';
import LogoutHOC from '../../../modules/Auth/LogoutPopup/hoc/LogoutHOC';
import LogoutPopup from '../../../modules/Auth/LogoutPopup/LogoutPopup';
import { formatMessage } from '../../../translations/connectedIntlProvider';
import UserProfilePopup from '../../../modules/Auth/UserProfile/UserProfilePopup';
import UserProfilePopupHOC from '../../../modules/Auth/UserProfile/hoc/UserProfilePopupHOC';
import dashboard from "../../../assets/Images/001-house.svg"

interface IProps {
  changeLanguage: (lang: string) => void;
}
let isOpen = false;
const LeftNavBar = (props: any) => {
  /* eslint-disable jsx-a11y/anchor-is-valid */
  const handleChange = () => {
    const div = document.getElementById('left-sidebarNav');
    if (div !== null) {
      if (isOpen) {
        div.classList.add("closeNav");
        isOpen = false;
      } else {
        div.classList.remove("closeNav");
        isOpen = true;
      }
    }
  }

  const handleChange2 = () => {
    const div = document.getElementById('left-sidebarNav');
    if (div !== null) {

      div.classList.add("closeNav");
      isOpen = false;

    }
  }

  return (
    <React.Fragment>
      {
        props.showUserProfilePopup &&
        <UserProfilePopup
          id={props.id}
          userName={props.userName}
          userType={props.userType}
          modalClosed={props.UserProfileToggleHandler} />
      }
      {
        props.showLogoutPopup &&
        <LogoutPopup
          modalClosed={props.logoutPopupToggleHandler} />
      }

      <aside id="left-sidebarNav" className="shadow closeNav">
        <button id="nav-toogle" onClick={handleChange}><i className="fas fa-arrow-left"></i></button>
        <div className="nav-inner">
          <nav>
            <div className="sidebar-header">
              <div className="sidebar-logo">
                <img src={CentraIoTLogo} alt="logo" className="openNav-logo img-fluid"></img>
                <img src={CentraIoT_icon} alt="logo" className="closeNav-logo img-fluid"></img>
              </div>
            </div>

            <ul className="list-unstyled">
              <li title={formatMessage("iaq_sensors")} onClick={handleChange2}>
                <NavLink to={RoutesConstants.IAQSensor} activeClassName="active-menu" exact>
                  <img src={dashboardIcon} alt="logo"></img>
                  <span className="nav-text">
                    {<FormattedMessage id='iaq_sensors' />}
                  </span>
                </NavLink>
              </li>
              {props.userType === 'Administrator' &&
                <li title={formatMessage("User_Title")} onClick={handleChange2}>
                  <NavLink to={RoutesConstants.User} activeClassName="active-menu">
                    <img src={userIcon} alt="logo"></img>
                    <span className="nav-text">
                      {<FormattedMessage id='User_Title' />}
                    </span>
                  </NavLink>
                </li>
              }
              <li title={formatMessage("Sensor_Title")} onClick={handleChange2}>
                <NavLink to={RoutesConstants.Sensor} activeClassName="active-menu" exact>
                  <img src={sensorIcon} alt="logo"></img>
                  <span className="nav-text">
                    {<FormattedMessage id='Sensor_Title' />}
                  </span>
                </NavLink>
              </li>
              <li title={formatMessage("Download_Title")} onClick={handleChange2}>
                <NavLink to={RoutesConstants.Download} activeClassName="active-menu">
                  <img src={downloadIcon} alt="logo"></img>
                  <span className="nav-text">
                    {<FormattedMessage id='Download_Title' />}
                  </span>
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
        <div className="aside-footer">
          <ul>
            <li title={formatMessage("User_Profile")} onClick={() => { props.UserProfileToggleHandler(); handleChange2() }}>
              <i className="fas fa-user-circle"></i>
              {/* <span className="nav-text"><FormattedMessage id='User_Profile'/></span> */}
            </li>
            <li title={formatMessage("Logout")} className="logout" onClick={props.logoutPopupToggleHandler}>
              <i className="fa fa-power-off pr-0"></i>
            </li>
          </ul>
          <p className="version">
            <FormattedMessage id='Version' /> 0.2.6</p>
        </div>
      </aside >
    </React.Fragment >
  )
}

export default withRouter(UserProfilePopupHOC(LogoutHOC(injectIntl(LeftNavBar))));